// 弹窗管理器
import { ref } from 'vue'
import EventBus from '@/utils/bus'
import dayjs from 'dayjs'
class PopupManager {
    queue: { component: any; params: any }[] = []
    currentPopup = ref<{ component: any; params: any } | null>(null)
    isChecking = false
    timer = null
    canLoop = false
    clickedStack: string[] = [] // 存储已点击的弹窗

    constructor() {
        this.checkStatus()
    }
    checkStatus() {
        const popStatus = this.getLocal()
        const { checkTime, clickedStack = [] } = popStatus
        if (Object.keys(popStatus).length) {
            if (!dayjs().isSame(checkTime, 'day')) {
                // 新的一天，重置已点击的弹窗
                this.clickedStack = []
            } else {
                this.clickedStack = clickedStack
                // 如果没有忽略的，不需要统一查了
                if (!this.clickedStack.length) {
                    EventBus.emit('checkPoint')
                }
            }
        } else {
            // 初始状态
            this.clickedStack = []
        }
        this.setLocal({
            clickedStack: this.clickedStack,
            checkTime: dayjs().format('YYYY-MM-DD'),
        })
    }
    restStatus() {
        this.canLoop = false
        this.clickedStack = []
        localStorage.removeItem('popStatus')
    }
    popStack(name) {
        // 添加到已点击列表
        if (!this.clickedStack.includes(name)) {
            this.clickedStack.push(name)
        }
        this.setLocal({
            clickedStack: this.clickedStack,
        })
    }
    getLocal() {
        const local = localStorage.getItem('popStatus')
        return local ? JSON.parse(local) : {}
    }

    setLocal(param = {}) {
        const prev = this.getLocal()
        localStorage.setItem(
            'popStatus',
            JSON.stringify({
                ...prev,
                ...param,
            })
        )
    }
    checkEndCB() {
        this.canLoop = false
        EventBus.emit('checkDialogEnd')
        // this.setLocal({
        //     checkTime: dayjs().format('YYYY-MM-DD'),
        //     clickedStack: this.clickedStack,
        // })
    }

    addPopup(component: any, params: any = {}, loop = false) {
        loop && (this.canLoop = true)
        this.queue.push({ component, params })
    }
    insertPopup(component: any, params: any = {}) {
        this.queue.unshift({ component, params })
    }
    clearQueue() {
        this.queue = []
        this.isChecking = false
    }
    startCheck() {
        if (this.isChecking) {
            return
        }
        this.isChecking = true
        this.checkQueue()
    }
    stopCheck() {
        this.clearQueue()
        this.closeCurrentPopup()
    }
    delayCheckQueue() {
        EventBus.emit('checkPoint')
        // const handleCb = () => {
        //     if (this.timer) {
        //         this.timer && clearTimeout(this.timer)
        //         this.timer = null
        //         this.clearQueue()
        //         EventBus.emit('checkPoint')
        //     }
        //     document.removeEventListener('click', handleCb, true)
        // }
        // document.addEventListener('click', handleCb, true)
        // this.timer = setTimeout(() => {
        //     this.timer = null
        //     document.removeEventListener('click', handleCb, true)
        //     this.checkQueue()
        // }, 6000)
    }
    checkLoopedQueue(name) {
        name && this.popStack(name)
        this.getComponent()
    }

    // 关闭传入组件，继续检查后续组件
    checkQueue(skip = '') {
        skip && this.popStack(skip)
        if (this.queue.length === 0) {
            this.isChecking = false
            this.currentPopup.value = null
            if (this.canLoop) {
                this.checkEndCB()
            }

            return
        }

        this.getComponent()
    }

    // 刷新当前组件
    getComponent() {
        const nextPopup = this.queue.shift()
        if (nextPopup) {
            this.currentPopup.value = nextPopup
        } else {
            this.stopCheck()
        }
    }

    closeCurrentPopup() {
        this.currentPopup.value = null
        this.checkQueue()
    }
}

export default new PopupManager()
